import { useLayoutEffect, useState } from "react";

import useResponsive from "libs/helpers/useResponsive";

const useHighlight = (element, step) => {
  const [isAvailable, setIsAvailable] = useState(false);

  const { max } = useResponsive();

  useLayoutEffect(() => {
    const tooltip = document.getElementsByClassName(
      "task-onboarding__tooltip",
    )?.[0];
    const highlight = document.getElementsByClassName(
      "task-onboarding__highlight",
    )?.[0];
    const target =
      document.getElementsByClassName(element?.target)?.[0] ||
      document.getElementById(element?.target);

    const placement = element?.placement || "bottom";
    const offset =
      typeof element?.offset === "number"
        ? element.offset * (max.lg ? 0.5 : max.xxl ? 0.6667 : 1)
        : max.lg
          ? 12
          : max.xxl
            ? 16
            : 24;
    const gap =
      element?.gap * (max.lg ? 0.5 : max.xxl ? 0.6667 : 1) || max.lg
        ? 8
        : max.xxl
          ? 12
          : 16;

    const handleHighlight = () => {
      if (tooltip && highlight && target) {
        const target_rect = target.getBoundingClientRect();

        highlight.style.width = `${target_rect.width + offset * 2}px`;
        highlight.style.height = `${target_rect.height + offset * 2}px`;
        highlight.style.top = `${target_rect.top - offset}px`;
        highlight.style.left = `${target_rect.left - offset}px`;

        const position = target.style.position;
        if (position === "" || position === "static") {
          target.style.position = "relative";
        }

        target.style.zIndex = 2102;

        let tooltip_top, tooltip_left;

        if (placement.startsWith("top")) {
          tooltip_top = target_rect.top - tooltip.offsetHeight - offset - gap;
        } else if (placement.startsWith("bottom")) {
          tooltip_top = target_rect.top + target_rect.height + offset + gap;
        } else if (placement === "right" || placement === "left") {
          tooltip_top =
            target_rect.top + target_rect.height / 2 - tooltip.offsetHeight / 2;
        } else if (placement.endsWith("-bottom")) {
          tooltip_top =
            target_rect.top +
            target_rect.height +
            offset -
            tooltip.offsetHeight;
        } else if (placement.endsWith("-top")) {
          tooltip_top = target_rect.top - offset;
        }

        if (placement === "top" || placement === "bottom") {
          tooltip_left =
            target_rect.left + target_rect.width / 2 - tooltip.offsetWidth / 2;
        } else if (placement.startsWith("right")) {
          tooltip_left = target_rect.left + target_rect.width + offset + gap;
        } else if (placement.startsWith("left")) {
          tooltip_left = target_rect.left - tooltip.offsetWidth - offset - gap;
        } else if (placement.endsWith("-right")) {
          tooltip_left =
            target_rect.left + target_rect.width - tooltip.offsetWidth + offset;
        } else if (placement.endsWith("-left")) {
          tooltip_left = target_rect.left - offset;
        }

        tooltip.style.top = `${tooltip_top}px`;
        tooltip.style.left = `${tooltip_left}px`;

        setIsAvailable(true);
      }
    };

    handleHighlight();

    window.addEventListener("resize", handleHighlight);

    if (max.lg) {
      document.addEventListener("scroll", handleHighlight);
    } else {
      document.body.addEventListener("scroll", handleHighlight);
    }

    return () => {
      if (target) {
        target.style.position = "";
        target.style.zIndex = "";
      }

      window.removeEventListener("resize", handleHighlight);
      document.removeEventListener("scroll", handleHighlight);
      document.body.removeEventListener("scroll", handleHighlight);
    };
  }, [element, step, max.xxl, max.lg]);

  return isAvailable;
};

export default useHighlight;
